import client from '../httpClient';

// sendmail017
const postSendRecommendMails = (params) => {
  return client.post('/send-mails/recommend', params);
};

export default postSendRecommendMails;
